module.exports = __webpack_public_path__ + "static/media/tourism_hp.20596d9d.jpg";